class CountdownTimer {
  constructor(elements) {
    this.elements = elements;

    var xhr = new XMLHttpRequest();
    xhr.open("GET", 'https://skweb.io/timeleft?date=' + this.elements[0].dataset.endDate, true);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
          var res = JSON.parse(xhr.responseText);
          var deadline_milli = res.timeleft;
          for (var i = 0; i < this.elements.length; i++) {
            this.countDown(elements[i], deadline_milli, false);
          }
          //this.countDown(deadline_milli, false);
        } else {
          if (!this.dataset.endDate) {
            return null;
          }
          for (var i = 0; i < this.elements.length; i++) {
            this.countDown(elements[i], 0, true);
          }
          //this.countDown(0, true);
        }
      }
    };
    xhr.send();
  }

  countDown(element, deadline, error) {
    const hideDayClass = 'hide-day';
    const hideDayPluralClass = 'hide-day-plural';
    const container = element.querySelector("#timer-container");
    const timerDay = element.querySelector("#timer-day");
    const timerHour = element.querySelector("#timer-hour");
    const timerMin = element.querySelector("#timer-min");
    const timerSec = element.querySelector("#timer-sec");

    let t = error ? new Date(element.dataset.endDate) - new Date().getTime() : deadline;

    let x = setInterval(function() {
      let days = Math.floor(t / (1000 * 60 * 60 * 24));
      let hours = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((t % (1000 * 60)) / 1000);
      t -= 1000;

      if (days <= 0) {
        container.classList.add(hideDayClass);
      }
      if (days == 1) {
        container.classList.add(hideDayPluralClass);
      }
      timerDay.innerHTML = days;
      timerHour.innerHTML = hours;
      timerMin.innerHTML = minutes;
      timerSec.innerHTML = seconds;
      if (t < 0) {
        clearInterval(x);
        timerDay.innerHTML = '0';
        timerHour.innerHTML = '0';
        timerMin.innerHTML = '0';
        timerSec.innerHTML = '0';
        container.classList.remove(hideDayClass);
      }
    }, 1000);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const countdownElements = document.querySelectorAll('countdown-timer');
  if (countdownElements.length > 0) {
    const validCountdownElements = Array.from(countdownElements).filter(element => element.dataset.endDate);
    new CountdownTimer(validCountdownElements);
  }
});
